module.exports = __webpack_public_path__ + "img/qrcode_icon.bd91e86e.svg";